import React from 'react';
import { IconProps } from '../IconProps';
const SvgNoSmoking = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M21.2365 12.1009C20.8951 12.1009 20.5485 11.9693 20.2889 11.708C19.6205 11.0377 18.728 10.668 17.7769 10.668C14.3458 10.668 11.5547 7.87686 11.5547 4.44575V4.0013C11.5547 3.2653 12.152 2.66797 12.888 2.66797C13.624 2.66797 14.2214 3.2653 14.2214 4.0013V4.44575C14.2214 6.40664 15.816 8.0013 17.7769 8.0013C19.4409 8.0013 21.0036 8.64841 22.1787 9.8253C22.6978 10.3462 22.6978 11.1906 22.1787 11.7115C21.9191 11.9711 21.576 12.1009 21.2365 12.1009Z"
      fill={primaryColor}
    />
    <path
      d="M25.136 8.19668C24.7947 8.19668 24.4533 8.0669 24.1938 7.80557C22.5991 6.2109 20.4782 5.33268 18.224 5.33268C17.488 5.33268 16.8906 4.73535 16.8906 3.99935C16.8906 3.26335 17.488 2.66602 18.224 2.66602C21.1911 2.66602 23.9804 3.82157 26.08 5.92113C26.6009 6.44202 26.6009 7.28646 26.08 7.80735C25.8204 8.06691 25.4773 8.19668 25.136 8.19668Z"
      fill={primaryColor}
    />
    <path
      d="M27.1111 17.7773H19.8791L10.9902 26.6662H27.1111C28.8267 26.6662 30.2222 25.2707 30.2222 23.5551V20.8885C30.2222 19.1729 28.8267 17.7773 27.1111 17.7773ZM27.5555 23.5551C27.5555 23.8005 27.3564 23.9996 27.1111 23.9996H21.3333V20.444H27.1111C27.3564 20.444 27.5555 20.6431 27.5555 20.8885V23.5551Z"
      fill={primaryColor}
    />
    <path
      d="M4.88846 26.6662H5.3329L14.2218 17.7773H4.88846C3.1729 17.7773 1.77734 19.1729 1.77734 20.8885V23.5551C1.77734 25.2707 3.1729 26.6662 4.88846 26.6662Z"
      fill={primaryColor}
    />
    <path
      d="M3.55555 29.7778C3.21421 29.7778 2.87288 29.648 2.61332 29.3867C2.09243 28.8658 2.09243 28.0213 2.61332 27.5005L27.5022 2.61332C28.0231 2.09243 28.8676 2.09243 29.3885 2.61332C29.9093 3.13421 29.9093 3.97866 29.3885 4.49955L4.49777 29.3867C4.23821 29.6462 3.89688 29.7778 3.55555 29.7778Z"
      fill={primaryColor}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.515 10.4468C28.2355 10.2951 28.9427 10.7563 29.0944 11.4769C29.251 12.2204 29.3328 12.9898 29.3328 13.7777V14.6666C29.3328 15.403 28.7358 15.9999 27.9995 15.9999C27.2631 15.9999 26.6661 15.403 26.6661 14.6666V13.7777C26.6661 13.175 26.6035 12.5897 26.485 12.0263C26.3331 11.3057 26.7943 10.5986 27.515 10.4468Z"
      fill={primaryColor}
    />
  </svg>
);
export default SvgNoSmoking;
